export default {
  setLoadingUploadForm(state, loadingUploadForm) {
    state.loadingUploadForm = loadingUploadForm;
  },
  setUploadForm(state, cteUploadForm) {
    state.cteUploadForm = Object.assign({}, state.cteUploadForm, cteUploadForm);
  },
  setLoadingUploadList(state, loadingUploadList) {
    state.loadingUploadList = loadingUploadList;
  },
  setUploadList(state, cteUploadList) {
    state.cteUploadList = cteUploadList;
  },
  setUploadListTotal(state, cteUploadListTotal) {
    state.cteUploadListTotal = cteUploadListTotal;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/cte-upload/store/mutations.js